import React, {FC} from 'react'
import s from './index.module.scss'
import Logo from "../../../../img/brand-new-logo.svg";
import ExternalLink from "../../../common/externalLink";
import {GiftContent} from "../index";
import VideoFrame from "../../../gift-strapi-content/video-frame";

type Props = {
  renderForm: () => any
  content: GiftContent
}

const Register: FC<Props> = ({content, renderForm}) => {
  return (
    <div id='form' className={s.root}>
      <div className={s.content}>
        <div className={s.image}>
          <div className={s.topContent}>
            <ExternalLink to="https://flyxo.com">
              <img className={s.logo} src={Logo} alt="XO logo"/>
            </ExternalLink>
            <h1 className={s.title}>{content?.title || 'The open future of private aviation.'}</h1>
            <div className={s.subTitle}>{content?.sub_title}</div>
            <div className={s.text} dangerouslySetInnerHTML={{__html: content?.text}}/>
            {!content?.video_link ? null : <div className={s.video}><VideoFrame src={content.video_link} title={content.video_title} /></div>}
          </div>
          <div className={s.bottomContent}>
            <div className={s.disclaimer} dangerouslySetInnerHTML={{__html: content?.disclaimer}}/>
          </div>
        </div>
        <div className={s.formContent}>
          {renderForm()}
        </div>
      </div>
    </ div>
  )
}

export default Register
